module.exports = __webpack_public_path__ + "static/media/mashangbanguanli.338206fc.png";